module.exports = __webpack_public_path__ + "static/logo-randstad-baulen-e1971de0f49961aa0f0657ea4de70354.svg";